<!-- eslint-disable catalyst/no-call-expression-with-args -->
@let rootNode = this.value();

<div
  class="p-tree p-component"
  [class.p-tree-selectable]="selectionMode()"
  [class.p-treenode-dragover]="dragHover()"
  [class.p-tree-loading]="loading()"
  [class.p-tree-flex-scrollable]="scrollHeight() === 'flex'"
  [style]="style() || ''"
  [class]="styleClass() ?? ''"
  (drop)="onDrop($event)"
  (dragover)="onDragOver($event)"
  (dragenter)="onDragEnter()"
  (dragleave)="onDragLeave($event)"
>
  @if (loading() && loadingMode() === "mask") {
    <div class="p-tree-loading-overlay p-component-overlay">
      @if (loadingIcon) {
        <i [class]="`p-tree-loading-icon pi-spin ${loadingIcon}`"></i>
      } @else if (!loadingIconTemplate()) {
        <standard-icon
          [icon]="faCircleNotch"
          styleClass="pi-spin p-tree-loading-icon"
        />
      } @else {
        <span class="p-tree-loading-icon">
          <ng-template *ngTemplateOutlet="loadingIconTemplate()!" />
        </span>
      }
    </div>
  }

  @if (headerTemplate()) {
    <ng-container *ngTemplateOutlet="headerTemplate()!" />
  }

  @if (rootNode?.length) {
    @if (virtualScroll()) {
      <div
        class="p-tree-virtual-container"
        [style.position]="'relative'"
        [style.--sticky-height]="`${stickyHeight()}px`"
      >
        @if (stickyParentNodes()) {
          <div class="p-tree-sticky-container">
            <ul
              class="p-tree-container p-tree-sticky-parents"
              role="tree"
              [attr.aria-label]="ariaLabel()"
              [attr.aria-labelledby]="ariaLabelledBy()"
              tabindex="-1"
            >
              @for (
                stickyNode of stickyParents();
                track virtualTrackBy($index, stickyNode);
                let stickyIndex = $index
              ) {
                <p-treeNode
                  #treeNode
                  [level]="stickyNode.level"
                  [node]="stickyNode.node"
                  [parentNode]="stickyNode.parent"
                  [firstChild]="stickyNode.firstChild"
                  [lastChild]="stickyNode.lastChild"
                  [index]="stickyNode.index"
                  [parentItemSize]="stickyParentItemSize()"
                  [childItemSize]="childItemSize()"
                  [indentation]="indentation()"
                  [loadingMode]="loadingMode()"
                  [ignoreDefaultTabOrder]="ignoreDefaultTabOrder"
                  [attr.is-sticky]="true"
                />
              }
            </ul>
          </div>
        }

        <cdk-virtual-scroll-viewport
          #scroller
          [tabindex]="-1"
          class="h-100"
          styleClass="p-tree-wrapper"
          [style.height]="
            scrollHeight() !== 'flex' ? scrollHeight() : undefined
          "
          [getItemSize]="getVirtualItemSize"
          (scrolledIndexChange)="onScrollIndexChangeInternal($event)"
        >
          <ul
            class="p-tree-container"
            role="tree"
            [attr.aria-label]="ariaLabel()"
            [attr.aria-labelledby]="ariaLabelledBy()"
          >
            <ng-container
              *cdkVirtualFor="
                let rowNode of serializedValue();
                trackBy: virtualTrackBy;
                let rowIndex = index;
                let count = count;
                let first = first;
                let last = last;
                let even = even;
                let odd = odd
              "
            >
              <p-treeNode
                #treeNode
                [level]="rowNode.level"
                [node]="rowNode.node"
                [parentNode]="rowNode.parent"
                [firstChild]="rowNode.firstChild"
                [lastChild]="rowNode.lastChild"
                [index]="rowNode.index"
                [parentItemSize]="parentItemSize()"
                [childItemSize]="childItemSize()"
                [indentation]="indentation()"
                [loadingMode]="loadingMode()"
                [ignoreDefaultTabOrder]="ignoreDefaultTabOrder"
              />
            </ng-container>
          </ul>

          @if (loaderTemplate()) {
            <ng-template pTemplate="loader" let-scrollerOptions="options">
              <ng-container
                *ngTemplateOutlet="
                  loaderTemplate();
                  context: { options: scrollerOptions }
                "
              />
            </ng-template>
          }
        </cdk-virtual-scroll-viewport>
      </div>
    } @else {
      <div
        #wrapper
        class="p-tree-wrapper"
        [style.max-height]="
          scrollHeight() !== 'flex' ? scrollHeight() : undefined
        "
      >
        <ul
          class="p-tree-container"
          role="tree"
          [attr.aria-label]="ariaLabel()"
          [attr.aria-labelledby]="ariaLabelledBy()"
        >
          @for (
            node of rootNode;
            track trackBy(index, node);
            let firstChild = $first;
            let lastChild = $last;
            let index = $index
          ) {
            <p-treeNode
              [node]="node"
              [firstChild]="firstChild"
              [lastChild]="lastChild"
              [index]="index"
              [level]="0"
              [loadingMode]="loadingMode()"
              [ignoreDefaultTabOrder]="ignoreDefaultTabOrder"
            />
          }
        </ul>
      </div>
    }
  }

  @if (!loading() && !rootNode?.length) {
    <div class="p-tree-empty-message">
      @if (!emptyMessageTemplate()) {
        {{ emptyMessageLabel }}
      } @else {
        <ng-container *ngTemplateOutlet="emptyMessageTemplate()!" />
      }
    </div>
  }

  @if (footerTemplate()) {
    <ng-container *ngTemplateOutlet="footerTemplate()!" />
  }
</div>
